import { forwardRef } from 'react';
import clsx from 'clsx';

const sizeClasses = {
  sm: 'max-w-md',
  md: 'max-w-2xl',
  lg: 'max-w-4xl',
  xl: 'max-w-6xl',
  full: 'max-w-none',
};

const ModalFrame = forwardRef(function ModalFrame({ children, className, size = 'md', ...props }, ref) {
  return (
    <div
      ref={ref}
      className={clsx(
        'flex min-h-0 max-h-[calc(100dvh-1.5rem)] w-full min-w-0 flex-col overflow-hidden rounded-lg bg-light-bg-primary shadow-xl outline-none dark:bg-dark-bg-secondary sm:max-h-[calc(100dvh-4rem)]',
        sizeClasses[size] || sizeClasses.md,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

const ModalFrameHeader = ({ children, className }) => (
  <div
    className={clsx(
      'flex min-w-0 shrink-0 flex-wrap items-start justify-between gap-3 border-b border-light-border-primary p-4 dark:border-dark-border-primary sm:p-6',
      className
    )}
  >
    {children}
  </div>
);

const ModalFrameBody = ({ children, className }) => (
  <div className={clsx('min-h-0 min-w-0 flex-1 overflow-y-auto p-4 sm:p-6', className)}>
    {children}
  </div>
);

const ModalFrameFooter = ({ children, className }) => (
  <div
    className={clsx(
      'min-w-0 shrink-0 border-t border-light-border-primary p-4 pb-[max(1rem,env(safe-area-inset-bottom))] dark:border-dark-border-primary sm:p-6',
      className
    )}
  >
    {children}
  </div>
);

ModalFrame.Header = ModalFrameHeader;
ModalFrame.Body = ModalFrameBody;
ModalFrame.Footer = ModalFrameFooter;

export { ModalFrameBody, ModalFrameFooter, ModalFrameHeader };
export default ModalFrame;
